import { useCallback } from 'react';

const companiesId = [
  'afb24a72-6660-41b8-b710-345068b0f8aa',
  '86826113-912a-47a4-82d4-14f86f64f6c8',
  '2a077425-02a9-4f75-805e-38a6458ae923',
  '4855bb9a-fbbf-4c78-9d40-725364b1c943',
  '46d1a06d-057b-4eec-80e6-94e00a44736b',
  '271e5bf0-4091-43e2-a4c4-5e989a9b90e8',
  'f1829ff9-cca1-4b7c-98c2-4fdb8bd19fcc',
  '1de59e17-dfbb-41b7-8e81-345aea5bbcb2',
  '52634351-8c52-4fbb-8d87-ffa7348982cc',
  '52c6d37f-b30d-4b0a-a677-fe0309e0a289',
  '2c6041da-7ec9-40f7-8de2-02dfcbd4696f',
  'f0ae62bf-342b-42a8-8c35-9072e9fd4e8e',
  '81aec4f2-61c6-4f3a-a93c-425aed2d7088',
  '5cf676dc-970f-41d1-b3c2-16ad1e43dc86',
  '0fd5cd5a-870a-4ccd-a20b-ae93f6d775a2',
  'addff1a6-34a7-4a35-aa5a-7d2590718afd',
  'c8bf4db6-de29-4b40-a2cd-ccb282ed2bde',
  '95748410-6a62-4b87-b537-2cf25f845ce7',
  '65b2e9e3-47c5-4a10-9cc5-12bab6a50f1d',
  'ad46766d-e612-476c-a65a-d3cc3a037be4',
  'b82c63d3-50f7-4c19-b922-b301ff0e2dd2',
  '62a15fde-ec42-4106-b01c-b1045751cea4',
  'c0e61546-6d30-48e1-b825-468bea66f61b',
  '9d4bdfd9-b857-489f-9fde-df3f3405de08',
  'fcbe975a-9ca6-4964-afe5-6f2e321802c6',
  '0edd66a6-637d-4b83-a0da-33bafd9ad155',
  '1f4b534f-05ba-4dc8-9adf-10176214be3f',
  '45d6d4b4-cb8f-47df-a3fa-83fe307a49f1',
  '3a7ebcd1-81c6-4975-a345-4b88ce47ce9b',
  '237e3d7f-c21f-4fac-9296-c5efbcc8f9e2',
  '4b6014dc-da39-4daa-899a-0af34dacd163',
  'a550e646-dbb2-4c7d-a493-4f39d8d8d649',
  '8d4edbbf-44ac-4d03-8dd8-418750563db2',
  '1f7e5d88-e947-472d-a8af-451b8eccddfb',
  '4e38f63d-9b56-49f9-a10e-dd3f666c808c',
  '6753780d-749a-47c2-8858-68bbbbf06ac2',
  '7cae47c0-cfd3-4e0b-bff9-df2d62f4ec12',
  '54581277-e75b-41b3-a484-e02a00d9e93a',
  '1832c00c-7de0-4ae6-9e31-d411c02c2a58', // SENAC PROD
  '0aa910c5-d0d5-4f70-bfc6-ca4f700a8d82', // SENAC DEV
  '0501d1c6-92de-40b5-bf88-516232f1c2a1', // INPASA
  'c51626b2-da88-496b-aa4c-818e7168300e', // INPASA 1
  'a51fa1bc-7f8a-49b9-aa2d-9e8bad785a04', // INPASA 2
  '77f80dab-a9b7-4774-a5cb-ac4494fbea25' // INPASA 3
];

function useFeatureFlags() {
  const byCompany = [
    {
      account_id: '6d306979-7681-47b7-9a81-acb6b11521c4',
      feature_flags: ['routingPermissions']
    }
  ];

  const byFeature = [
    {
      role: ['admin', 'manager'],
      feature: 'routingPermissions',
      allowList: [
        '7fe84bec-98ba-48f6-abdc-048d53ab4de0', // Travelex - Produção
        '6d306979-7681-47b7-9a81-acb6b11521c4', // Travelex - Homologação
        'f0dc31a1-9bd2-4b09-b880-7c6ba11aadf1', // HC
        'afb24a72-6660-41b8-b710-345068b0f8aa', // QA Environment
        '71aa7042-f0f8-438f-9663-389e2fd6c5a7' // Dev Environment
      ]
    },
    {
      role: ['admin', 'manager'],
      feature: 'mfa',
      allowList: [
        '7fe84bec-98ba-48f6-abdc-048d53ab4de0', // Travelex - Produção
        '6d306979-7681-47b7-9a81-acb6b11521c4', // Travelex - Homologação
        'afb24a72-6660-41b8-b710-345068b0f8aa', // QA Environment
        '71aa7042-f0f8-438f-9663-389e2fd6c5a7' // Dev Environment
      ]
    },
    {
      role: ['admin', 'manager'],
      feature: 'dataApp',
      allowList: [
        '271e5bf0-4091-43e2-a4c4-5e989a9b90e8', // Demo Prod
        'afb24a72-6660-41b8-b710-345068b0f8aa', // QA Environment
        '71aa7042-f0f8-438f-9663-389e2fd6c5a7', // Dev Environment
        '35984748-e0fc-420c-baa1-a1280aa9471b' // Demo semantix international
      ]
    },
    {
      role: ['admin', 'manager'],
      feature: 'dedicated-tools',
      allowList: [
        '7fe84bec-98ba-48f6-abdc-048d53ab4de0', // Travelex - Produção
        '6d306979-7681-47b7-9a81-acb6b11521c4', // Travelex - Homologação
        'afb24a72-6660-41b8-b710-345068b0f8aa', // QA Environment
        '71aa7042-f0f8-438f-9663-389e2fd6c5a7' // Dev Environment
      ]
    },
    {
      role: ['admin', 'manager'],
      feature: 'exportAccess',
      allowList: [
        'f0dc31a1-9bd2-4b09-b880-7c6ba11aadf1', // HC QA
        // '5edcefd6-d4b0-4fe7-87da-884c9f4701ca', // HC PROD
        'db2554e1-0b34-4451-befe-d24f23acd276', // AndreRavazzi
        'afb24a72-6660-41b8-b710-345068b0f8aa', // QA Environment
        '71aa7042-f0f8-438f-9663-389e2fd6c5a7' // Dev Environment
      ]
    },
    {
      role: ['admin', 'manager'],
      feature: 'data-catalog',
      allowList: [
        'afb24a72-6660-41b8-b710-345068b0f8aa', // QA Environment
        '71aa7042-f0f8-438f-9663-389e2fd6c5a7' // Dev Environment
      ]
    },
    {
      role: ['engineer', 'admin', 'scientist', 'manager'],
      feature: 'marketplace',
      allowList: [
        'f0ae62bf-342b-42a8-8c35-9072e9fd4e8e',
        '1f4b534f-05ba-4dc8-9adf-10176214be3f',
        'b82c63d3-50f7-4c19-b922-b301ff0e2dd2',
        '419a3941-9f47-41f5-876f-0f7e4d6ce764',
        '46d1a06d-057b-4eec-80e6-94e00a44736b', // caffeine-6llda8
        'f1829ff9-cca1-4b7c-98c2-4fdb8bd19fcc', // erural-g7c0vg
        '4e38f63d-9b56-49f9-a10e-dd3f666c808c', // unimed-s-hsijhp
        '95748410-6a62-4b87-b537-2cf25f845ce7', // sales-v2-kagxg4
        '4b6014dc-da39-4daa-899a-0af34dacd163', // Leo Santos
        '271e5bf0-4091-43e2-a4c4-5e989a9b90e8', // Demo Prod
        'afb24a72-6660-41b8-b710-345068b0f8aa', // QA Environment
        '71aa7042-f0f8-438f-9663-389e2fd6c5a7' // Dev Environment
      ]
    },
    {
      role: ['admin', 'manager'],
      feature: 'chat2dash',
      allowList: [
        'afb24a72-6660-41b8-b710-345068b0f8aa', // QA Environment
        '71aa7042-f0f8-438f-9663-389e2fd6c5a7', // Dev Environment
        '4b6014dc-da39-4daa-899a-0af34dacd163' // SparkV2 - Prod
      ]
    },
    {
      role: ['admin', 'manager'],
      feature: 'sdi_pipelines',
      allowList: [
        'afb24a72-6660-41b8-b710-345068b0f8aa', // QA Environment
        '71aa7042-f0f8-438f-9663-389e2fd6c5a7' // Dev Environment
      ]
    },
    {
      role: ['scientist', 'manager', 'admin', 'engineer', 'business'],
      feature: 'sandbox',
      allowList: companiesId
    },
    {
      role: ['engineer', 'manager', 'admin'],
      feature: 'pipelines',
      allowList: companiesId
    },
    {
      role: ['engineer', 'manager', 'admin'],
      feature: 'jobs',
      allowList: companiesId
    },
    {
      role: ['business', 'admin', 'manager', 'scientist', 'engineer'],
      feature: 'visualization',
      allowList: companiesId
    }
  ];

  const hasFeatureAccess = useCallback((role, feat, accountId) => {
    const filteredFeatures = byFeature.filter(
      (el) =>
        el.feature.toLowerCase() === feat.toLowerCase() &&
        el.allowList.includes(accountId) &&
        el.role.includes(role.toString().toLowerCase())
    );

    return !!filteredFeatures.length;
  }, []);

  return {
    byCompany,
    byFeature,
    hasFeatureAccess
  };
}

export default useFeatureFlags;
